import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = () => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return null; // App shows a spinner while loading
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!userProfile?.isAdmin) {
    return <Navigate to="/schedule" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
